export default function removeDoubleUrlSlashes(url) {
  return url.replace(/(:\/\/)|(\/)+/g, "$1$2")
}
